/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import { setSelectedClaimMode } from '../../store/action';
import { SelectedClaimModeData } from '../../utils/constant';

const SelectedClaimModeContainer = ({
  selectedClaimMode,
  specialConditionExists = false,
  isEnablebyRole,
  disableBtn,
  setBeforeSaveModeVal,
  handleOpenSave,
  setSuccessMessages
}) => {
  const rebateType = useSelector(
    (state) => state.sharedState.claim?.rebateType
  );
  const dispatch = useDispatch();
  return (
    <div className={`col-${specialConditionExists ? '3' : '4'} mt-4`}>
      <fieldset className="custom-fieldset">
        <legend className="same-font-family">Mode</legend>
        <div className="p-0 mt-2 row">
          <div className="mui-custom-form col-12 m-0 space-evenly">
            <FormControl>
              <RadioGroup
                row
                value={selectedClaimMode}
                onChange={(_, value) => {
                  setSuccessMessages([])
                  if (disableBtn) {
                    dispatch(setSelectedClaimMode(value));
                  } else {
                    handleOpenSave();
                    setBeforeSaveModeVal(value);
                  }
                  // _handleClick(value);
                }}
                className="justify-content-between justify-content-around"
              >
                {SelectedClaimModeData?.map((item, index) => (
                  <FormControlLabel
                    value={item.value}
                    control={<Radio />}
                    label={item.name}
                    id={item?.value}
                    key={`${item.value}_${index}`}
                    disabled={
                      !isEnablebyRole ||
                      (item.value === 'maintain'
                        ? rebateType === 'Supplemental'
                        : false)
                    }
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </div>
        </div>
      </fieldset>
    </div>
  );
};

export default SelectedClaimModeContainer;
